exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-form[data-v-29302d55] {\n  width: 400px;\n  margin: 0 auto;\n}\n.content-form .cancel[data-v-29302d55] {\n  display: block;\n  margin-top: 10px;\n  font-size: 16px;\n  text-align: center;\n  cursor: pointer;\n}", ""]);

// exports
